import React, { useState } from 'react';
import { Bell, BellOff, X, CheckCircle, AlertTriangle, Clock, Truck, Gift, MapPin } from 'lucide-react';

// Sirf Customer Notifications ka data
const INITIAL_NOTIFICATIONS = [
  { 
    id: 'c1', 
    unread: true, 
    type: 'Order', 
    title: 'Order Placed Successfully', 
    msg: 'Aapka order #957 successfully place ho gaya hai aur confirm ho gaya.', 
    time: '15 min pehle', 
    Icon: CheckCircle, 
  },
  { 
    id: 'c2', 
    unread: true, 
    type: 'Offer', 
    title: 'Special Discount!', 
    msg: 'Aaj ke orders par 20% off ka coupon aapke account mein add ho gaya.', 
    time: '1 ghante pehle', 
    Icon: Gift, 
  },
  { 
    id: 'c3', 
    unread: false, 
    type: 'Delivery', 
    title: 'Out for Delivery', 
    msg: 'Aapka order rider ke paas hai, agle 15 minute mein deliver hoga.', 
    time: '3 ghante pehle', 
    Icon: Truck, 
  },
  { 
    id: 'c4', 
    unread: false, 
    type: 'Update', 
    title: 'Address Updated', 
    msg: 'Aapki primary delivery address successfully update ho gayi.', 
    time: '1 din pehle', 
    Icon: MapPin, 
  },
];

function NotifCard({ n, onDismiss, theme }) {
  const Icon = n.Icon;
  
  // Dynamic colors based on theme and unread status
  const cardBg = n.unread ? theme.unreadBg : theme.cardBg;
  const borderColor = n.unread ? theme.borderUnread : theme.border;
  const titleColor = theme.textPrimary;
  const msgColor = theme.textSecondary;
  const timeColor = theme.textMuted;
  const typeColor = n.unread ? theme.accentText : theme.textMuted;
  const typeBg = n.unread ? theme.unreadBg : (theme.isDark ? 'rgba(255,255,255,0.05)' : '#f3f4f6');

  return (
    <div 
      style={{
        display: 'flex', 
        alignItems: 'flex-start', 
        gap: '12px',
        background: cardBg, 
        border: `1px solid ${borderColor}`,
        borderLeft: n.unread ? '4px solid #f97316' : '4px solid transparent',
        borderRadius: '10px', 
        padding: '14px 16px', 
        position: 'relative', 
        marginBottom: '10px',
        transition: 'all 0.2s ease',
        width: '100%',
        boxSizing: 'border-box',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow = theme.isDark 
          ? '0 4px 12px rgba(0,0,0,0.3)' 
          : '0 4px 12px rgba(249, 115, 22, 0.1)';
        e.currentTarget.style.transform = 'translateY(-1px)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow = 'none';
        e.currentTarget.style.transform = 'translateY(0)';
      }}
    >
      {n.unread && (
        <span style={{ 
          position: 'absolute', 
          top: '12px', 
          right: '12px', 
          width: '8px', 
          height: '8px', 
          borderRadius: '50%', 
          background: theme.unreadIndicator,
          boxShadow: `0 0 0 2px ${theme.isDark ? 'rgba(249, 115, 22, 0.3)' : 'rgba(249, 115, 22, 0.2)'}`
        }} />
      )}
      
      <div style={{ 
        width: '36px', 
        height: '36px', 
        borderRadius: '10px', 
        background: theme.accentBg, 
        color: theme.accentText, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        flexShrink: 0 
      }}>
        <Icon size={18} />
      </div>
      
      <div style={{ flex: 1, minWidth: 0, paddingRight: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '13px', fontWeight: '700', color: titleColor }}>{n.title}</span>
          <span style={{
            fontSize: '10px',
            color: typeColor,
            background: typeBg,
            padding: '2px 8px',
            borderRadius: '6px',
            fontWeight: 600,
          }}>
            {n.type}
          </span>
        </div>
        <p style={{ fontSize: '12px', color: msgColor, margin: '0 0 6px', lineHeight: '1.4' }}>
          {n.msg}
        </p>
        <span style={{ fontSize: '11px', color: timeColor, display: 'flex', alignItems: 'center', gap: '4px' }}>
          <Clock size={12} /> {n.time}
        </span>
      </div>
      
      <button 
        onClick={() => onDismiss(n.id)} 
        style={{ 
          background: 'none', 
          border: 'none', 
          cursor: 'pointer', 
          color: timeColor, 
          padding: '4px',
          flexShrink: 0,
          borderRadius: '6px',
          transition: 'all 0.2s',
          position: 'absolute',
          top: '10px',
          right: '10px',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = theme.dismissHoverBg;
          e.currentTarget.style.color = theme.dismissHoverText;
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
          e.currentTarget.style.color = timeColor;
        }}
      >
        <X size={14} />
      </button>
    </div>
  );
}

export default function CustomerNotifications({ isDark = false }) {
  const [notifications, setNotifications] = useState(INITIAL_NOTIFICATIONS);

  // 🎨 DYNAMIC THEME CONFIGURATION
  const theme = {
    isDark,
    bg: isDark ? '#0f172a' : '#f8fafc',
    cardBg: isDark ? '#1e293b' : '#ffffff',
    headerBg: isDark ? 'linear-gradient(135deg, #1e293b 0%, #334155 100%)' : 'linear-gradient(135deg, #ffffff 0%, #fff7ed 100%)',
    textPrimary: isDark ? '#f1f5f9' : '#0f172a',
    textSecondary: isDark ? '#cbd5e1' : '#4b5563',
    textMuted: isDark ? '#94a3b8' : '#9ca3af',
    border: isDark ? 'rgba(249, 115, 22, 0.2)' : '#e5e7eb',
    borderUnread: isDark ? 'rgba(249, 115, 22, 0.4)' : '#fed7aa',
    accentBg: isDark ? 'rgba(249, 115, 22, 0.15)' : '#fff7ed',
    accentText: isDark ? '#fb923c' : '#ea580c',
    unreadIndicator: '#f97316',
    unreadBg: isDark ? 'rgba(249, 115, 22, 0.1)' : '#fff7ed',
    emptyBg: isDark ? '#1e293b' : '#ffffff',
    dismissHoverBg: isDark ? 'rgba(239, 68, 68, 0.2)' : '#fee2e2',
    dismissHoverText: isDark ? '#f87171' : '#ef4444'
  };

  const totalUnread = notifications.filter(n => n.unread).length;

  const dismiss = (id) => {
    setNotifications(prev => prev.filter(n => n.id !== id));
  };

  const markAllRead = () => {
    setNotifications(prev => prev.map(n => ({ ...n, unread: false })));
  };

  return (
    <div style={{ 
      padding: '24px', 
      maxWidth: '600px', 
      margin: '0 auto', 
      fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
      background: theme.bg,
      minHeight: '100vh',
      transition: 'background-color 0.3s ease, color 0.3s ease',
    }}>

      {/* Header */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between', 
        padding: '16px 20px',
        background: theme.headerBg,
        borderRadius: '14px',
        border: `1px solid ${theme.border}`, 
        marginBottom: '20px',
        boxShadow: isDark ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(249, 115, 22, 0.08)',
        transition: 'all 0.3s ease',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{
            background: theme.accentBg,
            padding: '8px',
            borderRadius: '10px',
            color: theme.accentText,
            transition: 'all 0.3s ease',
          }}>
            <Bell size={20} />
          </div>
          <div>
            <span style={{ fontSize: '16px', fontWeight: '700', color: theme.textPrimary, display: 'block', transition: 'color 0.3s ease' }}>
              Notifications
            </span>
            <span style={{ fontSize: '12px', color: theme.textSecondary, transition: 'color 0.3s ease' }}>
              {totalUnread > 0 ? `${totalUnread} unread messages` : 'All caught up!'}
            </span>
          </div>
        </div>
        
        {totalUnread > 0 && (
          <button 
            onClick={markAllRead} 
            style={{ 
              fontSize: '12px', 
              fontWeight: '600',
              color: theme.accentText, 
              background: theme.unreadBg, 
              border: 'none', 
              cursor: 'pointer',
              padding: '6px 12px',
              borderRadius: '8px',
              transition: 'all 0.2s',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = isDark ? 'rgba(249, 115, 22, 0.2)' : '#ffedd5';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = theme.unreadBg;
            }}
          >
            Mark all read
          </button>
        )}
      </div>

      {/* Notifications List */}
      {notifications.length === 0 ? (
        <div style={{ 
          textAlign: 'center', 
          padding: '60px 20px', 
          background: theme.emptyBg,
          borderRadius: '14px',
          border: `1px solid ${theme.border}`,
          boxShadow: isDark ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(249, 115, 22, 0.08)',
          transition: 'all 0.3s ease',
        }}>
          <div style={{ 
            background: theme.accentBg, 
            width: '60px', 
            height: '60px', 
            borderRadius: '50%', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            margin: '0 auto 16px',
            transition: 'all 0.3s ease',
          }}>
            <BellOff size={28} color={theme.accentText} />
          </div>
          <p style={{ fontSize: '15px', fontWeight: '600', color: theme.textSecondary, margin: '0 0 4px', transition: 'color 0.3s ease' }}>
            Koi notification nahi
          </p>
          <p style={{ fontSize: '13px', margin: 0, color: theme.textMuted, transition: 'color 0.3s ease' }}>
            Aapke saare notifications clear ho chuke hain!
          </p>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {notifications.map(n => (
            <NotifCard 
              key={n.id} 
              n={n} 
              onDismiss={dismiss}
              theme={theme}
            />
          ))}
        </div>
      )}
    </div>
  );
}